import { render } from "./PriceCampaign.vue?vue&type=template&id=db42d222&scoped=true"
import script from "./PriceCampaign.vue?vue&type=script&lang=js"
export * from "./PriceCampaign.vue?vue&type=script&lang=js"

import "./PriceCampaign.vue?vue&type=style&index=0&id=db42d222&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db42d222"]])

export default __exports__